import React, { createContext, useReducer } from 'react';

export const SidenavContext = createContext(null);
const SHOW_SIDENAV = 'SHOW_SIDENAV';
const HIDE_SIDENAV = 'HIDE_SIDENAV';

const initialValues = {
  show: true,
};

//reducer fow showing and hiding sidenav
const reducer = (state = initialValues, action) => {
  switch (action.type) {
    case SHOW_SIDENAV:
      return {
        ...state,
        show: true,
      };
    case HIDE_SIDENAV:
      return {
        ...state,
        show: false,
      };
    default:
      return state;
  }
};

const showSideNavAction = () => ({ type: SHOW_SIDENAV });
const hideSideNavAction = () => ({ type: HIDE_SIDENAV });

const SideNavContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialValues);

  const showSideNav = () => dispatch(showSideNavAction());
  const hideSideNav = () => dispatch(hideSideNavAction());

  return (
    <SidenavContext.Provider value={{ showSideNav, hideSideNav, ...state }}>
      {children}
    </SidenavContext.Provider>
  );
};

export default SideNavContextProvider;
